var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmbed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Einbetten"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Einbetten",
    clipPath: "url(#clip-Einbetten)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1410",
    transform: "translate(-16828 -4691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1409"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_537",
    d: "M74.964,29.007a1,1,0,0,1-.707-.293l-5.508-5.507a1,1,0,0,1,0-1.414l5.508-5.507A1,1,0,1,1,75.671,17.7l-4.8,4.8,4.8,4.8a1,1,0,0,1-.707,1.707",
    transform: "translate(16769 4691)",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_538",
    d: "M88.96,29.007a1,1,0,0,1-.707-1.707l4.8-4.8-4.8-4.8a1,1,0,0,1,1.414-1.414l5.508,5.507a1,1,0,0,1,0,1.414l-5.508,5.507a1,1,0,0,1-.707.293",
    transform: "translate(16769 4691)",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_539",
    d: "M78.964,34.5A1,1,0,0,1,78,33.237l6-22a1,1,0,1,1,1.929.526l-6,22a1,1,0,0,1-.964.737",
    transform: "translate(16769 4691)",
    fill: "inherit"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbed);
export default __webpack_public_path__ + "static/media/embed.92d9d838.svg";
export { ForwardRef as ReactComponent };